<template>
  <b-card>
    <h4 class="mb-2">
      <font-awesome-icon class="mr-50 ml-1" icon="fa-solid fa-calculator" /> 商品分類
    </h4>
    <b-tabs pills>
      <!-- Tab: types -->
      <b-tab active v-if="ability.can('read', 'settings_product_type')">
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-people-carry-box"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">類別</span>
        </template>

        <types-list class="" />
      </b-tab>
      <!-- Tab: unit-->
      <b-tab v-if="ability.can('read', 'settings_product_unit')">
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-truck-field"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">單位</span>
        </template>

        <units-list class="" />
      </b-tab>
      <b-tab v-if="ability.can('read', 'settings_product_status')">
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-info"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">狀態</span>
        </template>

        <statuses-list class="" />
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import typesList from "./type/types-list/typesList.vue";
import unitsList from "./unit/units-list/unitsList.vue";
import statusesList from "./status/statuses-list/statusesList.vue";
import ability from "@/libs/acl/ability";

export default {
  components: {
    typesList,
    unitsList,
    statusesList,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  data(){
    return{
      ability
    }
  },
  setup() {},
};
</script>
